"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styles = exports.SplashError = exports.TEST_ID = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const loader_1 = require("@nib/loader");
const VisuallyHidden_1 = require("../VisuallyHidden");
const styles_1 = require("../../styles");
const global_utils_1 = require("../../utils/global-utils");
const S = __importStar(require("./SplashError.style"));
const SplashError_content_1 = __importDefault(require("./SplashError.content"));
const icons_1 = require("../../icons");
// Skip a beat before executing retry callback, to display
// loading spinner for a minimum amount of time.
const RETRY_DELAY = 1000; // ms
exports.TEST_ID = "SplashError__TestId";
const SplashError = _ref => {
  let {
    title = SplashError_content_1.default.TITLE,
    text = SplashError_content_1.default.TEXT,
    callback,
    buttonText = SplashError_content_1.default.BUTTON_TEXT,
    buttonProps = {}
  } = _ref;
  const [isRetrying, setIsRetrying] = (0, react_1.useState)(false);
  return (0, jsx_runtime_1.jsxs)(S.Wrapper, {
    "data-testid": exports.TEST_ID,
    children: [(0, jsx_runtime_1.jsx)(S.ErrorIcon, {
      children: (0, jsx_runtime_1.jsx)(icons_1.NibbySadGraphicIcon, {})
    }), (0, jsx_runtime_1.jsx)(S.ErrorTitle, {
      children: title
    }), (0, jsx_runtime_1.jsx)(S.ErrorText, {
      children: text
    }), callback && (0, jsx_runtime_1.jsx)(S.ErrorButton, Object.assign({
      onClick: () => {
        setIsRetrying(true);
        setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
          yield (0, global_utils_1.execPromiseCallback)(callback);
          setIsRetrying(false);
        }), RETRY_DELAY);
      }
    }, buttonProps, {
      children: isRetrying ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
        children: [(0, jsx_runtime_1.jsx)(VisuallyHidden_1.VisuallyHidden, {
          text: SplashError_content_1.default.TRYING_AGAIN
        }), "\u200b", (0, jsx_runtime_1.jsx)(loader_1.Loader, {
          size: "sm",
          fill: styles_1.variables.ERROR_BG_TEXT_COLOR
        })]
      }) : buttonText
    }))]
  });
};
exports.SplashError = SplashError;
exports.Styles = __importStar(require("./SplashError.style"));